import { withWindow } from '@shared/utils/withWindow';

const DEFAULT_LANGUAGE = 'en-US';

export const readNavigatorLanguage = (fallbackLanguage: Navigator['language'] = DEFAULT_LANGUAGE) => {
  return withWindow(global => global.navigator.language, undefined) || fallbackLanguage;
};
